// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__1Ho4f","container":"container__1ivV2","image":"image__8UQJl","vishivka":"vishivka__1eVG2","upper":"upper__1iFy3","lower":"lower__81wlT","text":"text__1KX0C"};